<template>
  <v-container fluid="" class="ma-0 pa-0">
    <v-row>
      <v-col class="col-12 col-md-6 col-lg-4">
        <pricecard
          name="Starter Plan"
          price="Free"
          :loading="loading"
          :features="features.free"
          :selected="labels.includes('starter')"
          @click="onClick('starter')"
        >
          <template slot="pretext">
            <p class="body-1">
              The first 10 learners are free,<br />
              then $3 per enrollment
            </p>
          </template>
        </pricecard>
      </v-col>
      <v-col class="col-12 col-md-6 col-lg-4">
        <pricecard
          name="Growth Plan"
          price="$999/month"
          :loading="loading"
          :features="features.growth"
          :selected="labels.includes('growth')"
          @click="onClick('growth')"
        >
          <template slot="pretext">
            <p class="body-1">
              Up to 200 learners
            </p>
          </template>
        </pricecard>
      </v-col>
      <v-col class="col-12 col-md-6 col-lg-4">
        <pricecard
          name="Enterprise Plan"
          :recommended="true"
          :loading="loading"
          price="Contact Us"
          :features="features.enterprise"
          @click="onClick('enterprise')"
        >
          <template slot="pretext">
            <p class="body-1">
              Get pricing tailored to your needs,<br />
              recommended for 500+ users
            </p>
          </template>
          <template slot="buttontext">
            Schedule Time
          </template>
        </pricecard>
      </v-col>
      <update
        v-model="showCard"
        :header="selectedPlan"
        :key="refresh"
        :plan="plan"
      />
    </v-row>
  </v-container>
</template>

<script>
import update from "../update-current-plan/index";
import stripecard from "../stripe-card";
import pricecard from "../pricing-card";
import services from "@/services";

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    stripecard,
    pricecard,
    update
  },
  data: () => ({
    showCard: false,
    refresh: 0,
    tab: null,
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    icons: false,
    centered: false,
    grow: false,
    vertical: false,
    prevIcon: false,
    nextIcon: false,
    right: false,
    tabs: 3,
    loading: true,
    selectedPlan: "",
    labels: [],
    plan: "",
    features: {
      free: [
        "Create unlimited courses",
        "Unlimited learners",
        "Charge for your courses",
        "Classroom analytics",
        "In-text quizzes and surveys",
        "Course previews",
        "Deploy courses across SMS and WhatsApp",
        "Free content guides"
      ],
      growth: [
        "Everything in Starter Plan",
        "Let learners enroll in seconds with no sign up",
        "Access our Content Editor community",
        "Unlimited admins",
        "Unlimited classrooms",
        "Your own logo + whitelabeling",
        "FERPA and SOPIPA compliance",
        "Integration support with Zapier"
      ],
      enterprise: [
        "Everything in Starter Plan",
        "Everything in Growth Plan",
        "Unlimited courses per learner",
        "Custom onboarding and workshops",
        "LMS and SSO integrations",
        "Seamless pilot options",
        "Let our team quickly create and covert courses for you",
        "Assign courses to learners",
        "Let learners enroll by texting a code",
        "Course library included"
      ]
    }
  }),
  watch: {
    showCard() {
      if (this.showCard) {
        this.refresh++;
      } else {
        this.loadLabels();
      }
    }
  },
  methods: {
    onClick(plan) {
      if (plan === "enterprise") {
        window.location = "http://lrn.st/30";
      }
      this.plan = plan;
      this.selectedPlan = plan === "starter" ? "Starter plan" : "Growth Plan";
      this.showCard = true;
    },
    async fetchLabels() {
      /**
       * @type {Array<Object>}
       */
      const subs = await services.billing.subscriptions.get();
      const details = [];
      subs.forEach(sub => {
        details.push(
          services.billing.subscriptions.getByID({ subscription: sub.id })
        );
      });
      const items = await Promise.all(details);
      const labels = [];
      items.forEach(sub => {
        /**
         * @type {Array}
         */
        const items = sub.items;
        if (!items || !Array.isArray(items)) {
          return;
        }
        items.forEach(item => {
          console.log(item);
          if (
            item &&
            item.price &&
            item.price.product &&
            item.price.product.metadata &&
            item.price.product.metadata.label
          ) {
            labels.push(item.price.product.metadata.label);
          }
        });
      });

      return labels;
    },
    async loadLabels() {
      try {
        this.loading = true;
        this.labels = await this.fetchLabels();
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    if (
      this.$store.getters["enterprise"] === "unloaded" ||
      this.$store.getters["enterprise"] === true
    ) {
      this.$router.push({ name: "billing-account" });
      return;
    }
    try {
      this.loading = true;
      await this.loadLabels();
    } catch (err) {
      console.error(err);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }
};
</script>
<style></style>
